import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { BriefcaseIcon, FileTextIcon, MailIcon } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    serviceInterest: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simulate form submission
    setSubmitted(true);
  };
  return <div className="w-full" data-id="element-1143" data-mp="1leexchb20g9s">
      {/* HERO SECTION */}
      <section className="section-navy hero-grid-pattern" data-id="element-1144" data-mp="1qdi4q8eiaykx">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15 text-center" data-id="element-1145" data-mp="1qg4b44pnv81k">
          <motion.div initial="hidden" animate="visible" variants={fadeIn} data-id="element-1146" data-mp="qzvoamo60by5">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight max-w-4xl mx-auto" data-id="element-1147" data-mp="n04mzp10idfd">
              Contact New River Systems
            </h1>
            <div className="h-1.5 w-24 bg-nrs-orange mx-auto rounded-full mb-6" data-id="element-1148" data-mp="d0vxp9h3dmzc"></div>
            <p className="text-xl text-nrs-light font-bold max-w-2xl mx-auto" data-id="element-1149" data-mp="d39rzg3y6v5u">
              Get in touch with our team
            </p>
          </motion.div>
        </div>
      </section>

      {/* CONTACT INFO */}
      <section className="section-white" data-id="element-1150" data-mp="3vewknd835y45">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 lg:px-15" data-id="element-1151" data-mp="3vfof2kpy5psu">
          
        </div>
      </section>

      {/* CONTACT FORM */}
      <section className="section-light-blue" data-id="element-1152" data-mp="3qdz1axbcay12">
        <div className="max-w-[800px] mx-auto px-5 md:px-10 lg:px-15" data-id="element-1153" data-mp="3lfnrunoyipjd">
          <h2 className="text-3xl font-bold text-center mb-10" data-id="element-1154" data-mp="3ghw1hy3ynbha">
            Send Us a Message
          </h2>

          {submitted ? <div className="bg-white p-8 rounded-lg shadow-sm text-center border-t-4 border-nrs-green" data-id="element-1155" data-mp="36tqobxs7sc3s">
              <h3 className="text-2xl font-bold text-nrs-navy mb-4" data-id="element-1156" data-mp="3bu4neqbu8bpo">
                Thank You
              </h3>
              <p className="text-lg text-nrs-gray" data-id="element-1157" data-mp="2xun42qhb9qnp">
                Thank you for contacting New River Systems. We'll respond within
                1 business day.
              </p>
              <button onClick={() => setSubmitted(false)} className="mt-8 btn-secondary" data-id="element-1158" data-mp="3plj76zdkkgxs">
                Send Another Message
              </button>
            </div> : <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-sm border border-gray-200" data-id="element-1159" data-mp="3gs66vcd6ed1o">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1160" data-mp="3ktjffu7nkuca">
                <div data-id="element-1161" data-mp="3krf08g4b08wp">
                  <label htmlFor="name" className="block text-sm font-bold text-nrs-navy mb-2" data-id="element-1162" data-mp="ce808qeucna0">
                    Name *
                  </label>
                  <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-nrs-navy focus:border-transparent" data-id="element-1163" data-mp="h698804z7ru8" />
                </div>
                <div data-id="element-1164" data-mp="2bjv7ofhj2x5s">
                  <label htmlFor="email" className="block text-sm font-bold text-nrs-navy mb-2" data-id="element-1165" data-mp="2bkdg0ahgt1u2">
                    Email *
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-nrs-navy focus:border-transparent" data-id="element-1166" data-mp="1ivzidvuag7j1" />
                </div>
              </div>

              <div className="mb-6" data-id="element-1167" data-mp="1nusubjtxfqh3">
                <label htmlFor="company" className="block text-sm font-bold text-nrs-navy mb-2" data-id="element-1168" data-mp="1ntr5mcjzn5gw">
                  Company (Optional)
                </label>
                <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-nrs-navy focus:border-transparent" data-id="element-1169" data-mp="2zar5bt8o0mky" />
              </div>

              <div className="mb-6" data-id="element-1170" data-mp="1dubbehwhjmz2">
                <label htmlFor="serviceInterest" className="block text-sm font-bold text-nrs-navy mb-2" data-id="element-1171" data-mp="1htsiffrk8s6c">
                  Service Interest *
                </label>
                <select id="serviceInterest" name="serviceInterest" required value={formData.serviceInterest} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-nrs-navy focus:border-transparent bg-white" data-id="element-1172" data-mp="1rs9dantmdqxo">
                  <option value="" disabled data-id="element-1173" data-mp="21k5matx8v1go">
                    Select One
                  </option>
                  <option value="ServiceNow" data-id="element-1174" data-mp="25lh5aglm4ofw">ServiceNow</option>
                  <option value="ICAM Services" data-id="element-1175" data-mp="2ak24qdt1j43a">ICAM Services</option>
                  <option value="Program Management" data-id="element-1176" data-mp="2fharkrp4vwav">Program Management</option>
                  <option value="General Inquiry" data-id="element-1177" data-mp="2plr5vgmyt5ck">General Inquiry</option>
                  <option value="Partnership Opportunity" data-id="element-1178" data-mp="2pjo4k0gd3psj">
                    Partnership Opportunity
                  </option>
                </select>
              </div>

              <div className="mb-8" data-id="element-1179" data-mp="2focq7j8v8klb">
                <label htmlFor="message" className="block text-sm font-bold text-nrs-navy mb-2" data-id="element-1180" data-mp="2fpeb0ffoolg8">
                  Message *
                </label>
                <textarea id="message" name="message" rows={5} required value={formData.message} onChange={handleChange} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-nrs-navy focus:border-transparent resize-y" data-id="element-1181" data-mp="38b77y8eat5v3"></textarea>
              </div>

              <button type="submit" className="btn-primary w-full md:w-auto" data-id="element-1182" data-mp="2ujsknpdcyii8">
                Send Message
              </button>
            </form>}
        </div>
      </section>
    </div>;
}